jQuery(document).ready(function($){
    // Check if mobile device
    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }
    var mobileNav = document.querySelector('.menu-open .menu-item ')
  
    if(mobileNav){

    } else {
    // Smooth scroll function on all on pagon page 
      if(isTouchDevice()){
          // Add smooth scrolling to all links
          $("a").not(".menu-item a").on('click', function(event) {
            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "") {
              // Prevent default anchor click behavior
              event.preventDefault();
              // Store hash
              var hash = this.hash;
              // Using jQuery's animate() method to add smooth page scroll
              // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
              $('html, body').animate({
                  scrollTop: $(hash).offset().top -100
              }, 800, function(){
                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
              });
            } // End if
          });
      } else {
        // Add smooth scrolling to all links
        $("a").not(".box").on('click', function(event) {
          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            // Store hash
            var hash = this.hash;
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top -260 
            }, 800, function(){
              // Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
            });
          } // End if
        });
      }
    }
});